import { Component, OnInit } from '@angular/core';
import { STATIC_DATA } from '../../../shared/constants/static-data.constants';
import { PAGE_CONSTANTS } from '../../../shared/constants/page.constants';
import { AuthorizationUtility } from '../../../shared/authorization/auth.utility';
import { AuthorizationService } from '../../../shared/authorization/authorization.service';
import { PageConfig } from '../../../shared/authorization/auth.config';
import { ListTableComponent } from '../../../shared/components/list-table/list-table.component';
import { ButtonComponent } from '../../../shared/components/button/button.component';
import { UserService } from '../../../services/user.service';
import { AutoFocusHeaderDirective } from '../../../shared/directives/auto-focus-header.directive';

@Component({
  selector: 'ppl-payroll-processing',
  standalone: true,
  imports: [ListTableComponent, ButtonComponent, AutoFocusHeaderDirective],
  templateUrl: './payroll-processing.component.html',
  styleUrl: './payroll-processing.component.css',
})
export class PayrollProcessingComponent implements OnInit {
  sharedDataKey: string = STATIC_DATA.SHARED_PAYROLL_PROCESSING_DATA;
  pageId: string = PAGE_CONSTANTS.PAYROLL_PROCESSING_GRID;
  columnsToBeHidden: string[] = [];
  actionsToBeHidden: string[] = [];
  isPageRestrictionLoaded = false;
  programName!: string;

  constructor(
    private authUtility: AuthorizationUtility,
    private authService: AuthorizationService,
    private userService: UserService
  ) {}

  ngOnInit(): void {
    const selectedProgram = this.userService.getSelectedProgram();
    this.programName = selectedProgram?.program_code ?? '';
    this.setPageAccess();
  }

  private setPageAccess() {
    const pageConfig = this.authUtility.getPageConfig(this.pageId);
    if (!pageConfig || !pageConfig.pageName) {
      this.authService
        .fetchPageAuthorization(this.programName, this.pageId, 'LIST')
        .subscribe((response) => {
          this.setRestrictions(response);
        });
    } else {
      this.setRestrictions(pageConfig);
    }
  }

  private setRestrictions(pageConfig: PageConfig) {
    if (pageConfig) {
      this.columnsToBeHidden = this.authUtility.getHiddenColumns(
        pageConfig,
        this.pageId
      );
      this.actionsToBeHidden = this.authUtility.getHiddenActions(
        pageConfig,
        this.pageId
      );
    }
    this.isPageRestrictionLoaded = true;
  }

  rowClicked(event: any) {
    console.log('Event', event);
  }
}
